import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { SET_SELECTED_FILTER } from 'estimate_list/reducers/initial'
import { useSelector, useDispatch } from 'react-redux'
import { filterTheorem } from 'estimate_list/libs/util'

const ItemLine = ({ children, types }) => {
    const [groupData, setGroupData] = useState([])

    useEffect(() => {
        if (types === 'thumb') setData()
    }, [children]) // eslint-disable-line

    const setData = () => {
        const child = [...children]
        const data = child.filter((v) => v)
        const groupLength = Math.ceil(data.length / 3)
        const emptyArr = new Array(groupLength)
        const sliceArr = emptyArr.fill('').map((v, i) => {
            return data.slice(i * 3, i * 3 + 3)
        })
        setGroupData(sliceArr)
    }

    if (types === 'list') return children
    return (
        <>
            {groupData.map((v, i) => (
                <Group key={i}>{v}</Group>
            ))}
        </>
    )
}

const Group = ({ children }) => {
    const { selectedFilters } = useSelector((state) => state.initial)
    const [view, setView] = useState(null)

    const dispatch = useDispatch()

    useEffect(() => {
        setView(null)
        children.forEach((e, i) => {
            if (e.props.data?.moreView) {
                setView(i)
            }
        })
    }, [children])

    const onClickSpec = (spec) => () => {
        // ex) specNameKey:37, specValueKey: 12345, specValue: '상품분류 : 인텔 CPU용'
        const { specNameKey, specValueKey, specValue } = spec
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'spec',
                value: { specNameKey, specValueKey, specValue: specValue.split(' : ')[1] },
            }),
        })
    }

    const active = ({ specNameKey, specValueKey }) => {
        const selectNameKey = selectedFilters.spec[specNameKey]
        if (selectNameKey) {
            const index = selectNameKey.findIndex((v) => v.specValueKey === specValueKey)
            return index > -1
        }
    }

    return (
        <Style>
            <div>{children}</div>
            {view !== null && (
                <More>
                    {children[view].props.data?.item_br_info?.map((spec) => (
                        <button
                            key={spec.specValueKey}
                            className={`detail ${active(spec) ? 'active' : ''}`}
                            onClick={onClickSpec(spec)}
                        >
                            {spec.specValue}
                        </button>
                    ))}
                </More>
            )}
        </Style>
    )
}

const Style = styled.div`
    display: block;
    margin: 30px 0 50px;
`

const More = styled.div`
    display: block;
    width: 100%;
    margin: 10px 0 0;
    padding: 20px;
    background: #f7f7fa;

    .detail {
        color: #666;
        display: inline-block;
        line-height: 18px;

        &:not(:last-child):after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 7px;
            background: #999;
            margin: 0 5px;
        }
        &:hover {
            text-decoration: underline;
        }
        &.active {
            color: #418ded;
        }
    }
`

export default ItemLine



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_line.js